import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-24 px-6" data-id="element-1">
      <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-12 mb-32" data-id="element-2">
        {/* For Whom */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-3">
          <h3 className="text-xl font-bold text-white mb-6" data-id="element-4">Para quién es</h3>
          <ul className="space-y-4" data-id="element-5">
            {['Ruptura reciente y dolor físico', 'La soledad es tu mayor gatillo', 'Recaes mandando mensajes', 'Quieres paz mental real'].map((item, i) => <li key={i} className="flex items-center gap-3 text-[#A8A8B3]" data-id="element-6">
                <CheckIcon className="w-5 h-5 text-[#5BB5A2]" data-id="element-7" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        {/* Not For Whom */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-8">
          <h3 className="text-xl font-bold text-[#A8A8B3] mb-6" data-id="element-9">
            No es para ti si…
          </h3>
          <ul className="space-y-4" data-id="element-10">
            {['Buscas técnicas para recuperarlo', 'Estás en situación de abuso/peligro'].map((item, i) => <li key={i} className="flex items-center gap-3 text-[#A8A8B3]/60" data-id="element-11">
                <XIcon className="w-5 h-5 text-[#E8636F]/60" data-id="element-12" />
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>

      {/* Truth Bomb Billboard */}
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} className="relative py-24 px-6 -mx-6 bg-gradient-to-r from-[#E8636F]/5 to-[#F4A261]/5 border-y border-white/5 text-center" data-id="element-13">
        <div className="max-w-3xl mx-auto" data-id="element-14">
          <p className="text-xs font-bold tracking-widest text-[#A8A8B3] uppercase mb-8" data-id="element-15">
            La verdad incómoda
          </p>
          <h3 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight" data-id="element-16">
            A veces no le escribes porque lo amas.
          </h3>
          <h3 className="text-4xl md:text-6xl font-heading font-extrabold text-gradient mb-8 leading-tight" data-id="element-17">
            Le escribes porque no quieres sentirte sola.
          </h3>
          <p className="text-xl text-[#A8A8B3] max-w-xl mx-auto" data-id="element-18">
            Y eso no se arregla con otro mensaje. Se arregla con un sistema que
            te sostenga cuando nadie te está viendo.
          </p>
        </div>
      </motion.div>
    </section>;
}